import React from 'react';
import classNames from 'classnames';

import { Link } from '@mm/components';
import { LoginType } from '@mm/state/controllers/SessionController';

import { SignUpLogo } from '../../../../../dashboard/pages/SignUp/SignUp/SignUpLogo/SignUpLogo';
import heroImage from './hero-image.png';
import bg from './bg.svg';

import { useAuthBtn } from '../use-auth-btn';
import css from './InviteLayout.module.css';
import { Badges } from '../components/Badges/Badges';

type Props = {
  className?: string;
  children?: any;
};

export const InviteLayout = ({ className, children }: Props) => {
  const { authBtnText, authLinkDestination } = useAuthBtn(LoginType.invite);

  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.background}>
        <div className={css.left} />
        <div className={css.right} />
      </div>

      <div className={css.container}>
        <div className={css.navbar}>
          <SignUpLogo className={css.logo} />
          <Link className={css.login} to={authLinkDestination}>
            {authBtnText}
          </Link>
        </div>

        <div className={css.content}>
          <div className={css.section}>
            <div className={css.card}>
              <Badges className={css.badges} />
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
